module.exports = {"451022100":"平马镇","451022101":"祥周镇","451022103":"林逢镇","451022105":"思林镇","451022106":"印茶镇","451022107":"江城镇","451022108":"朔良镇","451022109":"义圩镇","451022110":"那拔镇","451022201":"作登瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451022.json
// module id = 2271
// module chunks = 0